import type { ComponentProps } from "react";
import {
  Link as RRLink,
  NavLink as RRNavLink,
  Navigate as RRNavigate,
  useNavigate as useRRNavigate,
  type NavigateOptions,
} from "react-router-dom";
import type { RoutePath } from "@wedding/shared";

/**
 * react-router-dom'un navigasyon-YAZAN primitiflerinin marka-tipli sarmalayıcıları.
 *
 * `check:routes` bu dosyayı allowlist'e alır — ham `Link`/`NavLink`/`Navigate`/
 * `useNavigate` yalnız BURADA (+ `packages/ui/src/mobile-bottom-nav.tsx`) içe
 * aktarılabilir. `to` yalnız `RoutePath` kabul eder → `paths.ts` DIŞINDA üretilmiş
 * bir string buraya ASLA ulaşamaz; ulaşmayı denerse tsc hata verir.
 *
 * `Routes`/`Route`/`Outlet`/`useParams`/`useLocation`/`useSearchParams`/
 * `BrowserRouter` sarmalanmaz — bunlar okuma/yapı primitifleri, navigasyon hedefi
 * almazlar.
 *
 * Kapsam dışı (bilinçli): `to` için `Partial<Path>` (`{pathname,search,hash}`)
 * objesi — repoda hiç kullanılmıyor. Gerekirse union üyesi olarak eklenir.
 */

type AppLinkProps = Omit<ComponentProps<typeof RRLink>, "to"> & { to: RoutePath };
export function AppLink({ to, ...rest }: AppLinkProps) {
  return <RRLink to={to} {...rest} />;
}

type AppNavLinkProps = Omit<ComponentProps<typeof RRNavLink>, "to"> & { to: RoutePath };
export function AppNavLink({ to, ...rest }: AppNavLinkProps) {
  return <RRNavLink to={to} {...rest} />;
}

type AppNavigateProps = Omit<ComponentProps<typeof RRNavigate>, "to"> & { to: RoutePath };
export function AppNavigate({ to, ...rest }: AppNavigateProps) {
  return <RRNavigate to={to} {...rest} />;
}

/** `navigate(-1)` (delta) VE `navigate(to, options)` — ikisi de korunur. */
export interface AppNavigateFunction {
  (to: RoutePath, options?: NavigateOptions): void;
  (delta: number): void;
}

export function useAppNavigate(): AppNavigateFunction {
  return useRRNavigate() as AppNavigateFunction;
}
